import type {
  PortfolioAttribution,
  PortfolioAttributionAnalyticsProperties,
} from '@extern/portfolio/utils/portfolio-attribution-cookie';
import {
  buildPortfolioAttribution,
  parsePortfolioAttribution,
  readPortfolioAttributionCookie,
  toPortfolioAttributionAnalyticsProperties,
} from '@extern/portfolio/utils/portfolio-attribution-cookie';

export type {
  PortfolioAttribution,
  PortfolioAttributionAnalyticsProperties,
} from '@extern/portfolio/utils/portfolio-attribution-cookie';

export function isPortfolioPublicUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.pathname.includes('/portfolios/');
  } catch {
    return false;
  }
}

export function resolvePortfolioAttribution(input?: {
  cookieSource?: string;
  portfolioCode?: string | null;
  portfolioUrl?: string | null;
  utmContent?: string | null;
  referrer?: string | null;
}): PortfolioAttribution | null {
  const fromCookie = readPortfolioAttributionCookie(input?.cookieSource);

  if (fromCookie) {
    return fromCookie;
  }

  if (!(input?.portfolioCode && input.portfolioUrl && isPortfolioPublicUrl(input.portfolioUrl))) {
    return null;
  }

  try {
    return buildPortfolioAttribution({
      portfolioCode: input.portfolioCode,
      portfolioUrl: input.portfolioUrl,
      utmContent: input.utmContent,
      referrer: input.referrer,
    });
  } catch {
    return null;
  }
}

export function portfolioAttributionFromUnknown(value: unknown): PortfolioAttribution | null {
  if (typeof value === 'string') {
    return parsePortfolioAttribution(value);
  }

  if (!value || typeof value !== 'object') {
    return null;
  }

  return parsePortfolioAttribution(JSON.stringify(value));
}

export function flattenPortfolioAttribution(
  attribution: PortfolioAttribution | null | undefined,
): PortfolioAttributionAnalyticsProperties | Record<string, never> {
  if (!attribution) {
    return {};
  }

  return toPortfolioAttributionAnalyticsProperties(attribution);
}
